import * as React from "react";
import type { SVGProps } from "react";
const SvgMoreHorizontal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 12v2a2 2 0 0 0 2-2zm0 0h-2a2 2 0 0 0 2 2zm0 0v-2a2 2 0 0 0-2 2zm0 0h2a2 2 0 0 0-2-2zm7 0v2a2 2 0 0 0 2-2zm0 0h-2a2 2 0 0 0 2 2zm0 0v-2a2 2 0 0 0-2 2zm0 0h2a2 2 0 0 0-2-2zM5 12v2a2 2 0 0 0 2-2zm0 0H3a2 2 0 0 0 2 2zm0 0v-2a2 2 0 0 0-2 2zm0 0h2a2 2 0 0 0-2-2z"
    />
  </svg>
);
export default SvgMoreHorizontal;
